import { resetFocus } from 'owa-mail-focus-manager';
import {
    getSelectedTableView,
    type TableQueryType,
    MailRowDataPropertyGetter,
} from 'owa-mail-list-store';
import { lazyShowSweepDialog } from 'owa-mail-sweep-view';
import { getIsSharedMailbox } from 'owa-shared-mailbox';
import type { MailboxInfo } from 'owa-client-types';
import { logUsage } from 'owa-analytics';
import getEffectiveRowKeys from 'owa-mail-reading-pane-store/lib/utils/getEffectiveRowKeys';

export default function onSweep(
    mailboxInfo: MailboxInfo,
    targetWindow?: Window,
    itemId?: string,
    source?: string
): void {
    const tableView = getSelectedTableView();
    const rowKeys = getEffectiveRowKeys(tableView);
    let itemIdForSweep: string | undefined = itemId;

    // If it is a search, find the item id from the selected row keys
    if (tableView.tableQuery.type === 1) {
        itemIdForSweep = MailRowDataPropertyGetter.getItemIds(rowKeys[0], tableView)[0];
    }

    logUsage('TnS_SweepShowDialog', mailboxInfo, { source });

    getIsSharedMailbox(mailboxInfo);
    lazyShowSweepDialog.importAndExecute(
        rowKeys,
        tableView,
        mailboxInfo,
        targetWindow,
        itemIdForSweep
    );
    resetFocus('sweepCommand');
}
